module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_86524110_L-small-2f069ab1ed68adb0b23e70b34bce7aeb.jpg";